<template>
    <div class="container-fluid mt-4">
      <div class="row">
          <div class="col-2">
            <span v-if="userData.logo!=0"><img :src="getLogo(userData.logo)" height="100"/></span>
            <span v-else><img src="@/assets/images/logo.png" height="100"/></span>
          </div>
          <div class="col-7 mt-2">
            <h2 style="color:black;font-weight: 700; " class="text-uppercase mb-1">{{ userData.business }}</h2>
            <b style="color:black;font-size:12px">Location: {{ userData.location }}</b><br>
            <b style="color:black;font-size:12px">Contacts: {{ userData.contact }}</b><br>
            <b style="color:black;font-size:12px">E-mail: {{ userData.email }}</b><br>
            <b style="color:black;font-size:12px">Website: {{ userData.website }}</b> 
          </div>
          <div class="col-3 mt-3">
            <span style="color:black;font-size:13px;font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;"> Visit ID: <br> <b style="font-size: 20px;"> {{ this.visit_id }}</b> <br> Date : {{ visit_date }}</span>
          </div>
        </div>
        <hr style="border: 1px solid black;">
                
        <center><span style="color: black;font-family: tahoma;font-size:13px" class="text-decoration-underline text-uppercase"><b> Laboratory Results</b></span></center>
      <br><div class="d-flex justify-content-between">
      <span> Name: <b class=" h6">{{ patientData.name }} </b></span>
      <span> Patient ID: <b class=" h6">{{ patientData.patient_id }} </b></span>
      <span> Sex: <b class=" h6">{{ patientData.gender }} </b></span>
      <span> Age: <b class=" h6">{{ getAge(patientData.date_of_birth) }} yrs </b></span>
      <span> Telephone: <b class=" h6">0{{ patientData.telephone }} </b></span>
      </div>

        <div class="mt-4">
          <table class="table table-sm mt-2" style="color: black;" density="compact">
            <thead><tr><th>Test</th><th>Sample</th><th>Results</th></tr></thead>
            <tbody>
              <tr v-for="item in patientTest" :key="item.id">
                <td>{{ item.test.name }}</td>
                <td><span v-html="item.sample.name"></span></td>
                <td><span v-html="item.result"></span></td>
              </tr> 
            </tbody>
          </table>
        </div> 
              
        <div class="mt-3 text-center">
            <h5 style="color: black;" class="my-4 text-center">Signature : .........................</h5>
            <p style="color:black;font-size:13px">Printed by : {{ userData.username }} | Via Daherz Family Doctors | www.daherzfamilydoctors.com </p>
            
            <br><barcode :value="this.visit_id" height="50" display-value="false"></barcode>
          </div>
    </div>
</template>

<script>
import axios from "axios";
import VueBarcode from 'vue-barcode';

export default {
  components: { 'barcode': VueBarcode },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      patientTest:[],
      patientData:[],
      visit_date:new Date().toLocaleDateString('fr-CA'),
      visit_id:'',
    };
  },
  created() {
    this.showlabresults();
    this.showpatientinfo();
  },
  methods: {
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    getLogo(name){
        let url = axios.defaults.baseURL;
        let imagelink = (url).slice(0,-3)+"logos/"+name;
        return imagelink;
      },
      getAge(dateString){
      let birth = new Date(dateString); let now = new Date(); let beforeBirth = ((() => {birth.setDate(now.getDate());birth.setMonth(now.getMonth()); return birth.getTime()})() < birth.getTime()) ? 0 : 1;
      return now.getFullYear() - birth.getFullYear() - beforeBirth;
    },
      async showpatientinfo(){
      this.visit_id=this.$route.query.id;
      let formData = new FormData();
      formData.append("visit_id", this.visit_id);
      let url = "/findpatientlabinfo";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.patientData=response.data.patient;
        }
      })
    },
    async showlabresults(){
      this.visit_id=this.$route.query.id;
      let url = `/labpatientprofile/${this.visit_id}`;
      await axios.get(url).then((response) => {
        this.patientTest = response.data.results;
        setTimeout(() => { window.print(); window.onafterprint=this.$router.go(-1); }, 2500);
      });
    },
  },
};
</script>